import { render, staticRenderFns } from "./LoyaltyCollectionFlagSwitcher.vue?vue&type=template&id=f873c720"
import script from "./LoyaltyCollectionFlagSwitcher.vue?vue&type=script&lang=js"
export * from "./LoyaltyCollectionFlagSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports